export class LanguageModel {
  name: string;
}
